// Sentry MUST be imported first — the SDK installs global error handlers
// at module evaluation time, so anything imported above this line could
// throw before Sentry is wired up.
import "@/instrument";

import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Sentry, sentryEnabled } from "@/instrument";

const container = document.getElementById("root");

// React 19 root-level error hooks. These fire for errors NOT caught by
// any ErrorBoundary, errors that ARE caught by an ErrorBoundary (so we
// still log them centrally), and errors React auto-recovers from. Each
// wraps Sentry.captureException via Sentry.reactErrorHandler() when
// enabled; otherwise they no-op.
const rootOptions = sentryEnabled()
  ? {
      onUncaughtError: Sentry.reactErrorHandler(),
      onCaughtError: Sentry.reactErrorHandler(),
      onRecoverableError: Sentry.reactErrorHandler(),
    }
  : undefined;

const root = ReactDOM.createRoot(container, rootOptions);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
